import React from "react";
import { persistZero } from "../../../helpers/helperMethods";
import { useLocation } from "react-router-dom";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useIsDesignV2 } from "../../../hooks/useIsDesignV2";

interface IItemPrice {
  price: number;
  discountPrice: number;
  isRedeemed: boolean;
}

const ItemPrice: React.FC<IItemPrice> = (props) => {
  const { price, isRedeemed, discountPrice } = props;
  const location = useLocation();
  const isItMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  return (
    <div className="text-center">
      <span className="d-inline-block f-w5 font-Vcf f-s16 lh-normal">
        {isRedeemed ? (
          <>
              <span className={`free-tag d-inline-block me-2 ${isDesignV2 ? 'f-s15' : ''}`} data-testid={"cartItemDisount"}>{discountPrice > 0 ? `$${discountPrice}` : 'FREE'}</span>
              <span className="d-inline-block">
              <span className="clr-text-grey f-s14 font-Visby-cf d-block text-center mb-2">Total</span>
              <span className={`del-text ${isDesignV2 ? 'f-s15' : ''}`} data-testid={"cartItemPrice"}>{`\$${persistZero(price)}`}</span>
            </span>
          </>
        ) : (
            <>
            <span className="d-inline-block">
              <span className={`font-Visby-cf d-block text-center ${isDesignV2 ? 'mb-2 clr-lt-grey f-w5 f-s15' : 'f-s14 mb-2 clr-text-grey'}`}>Total</span>
              <span className={`${isDesignV2 ? 'f-w6 f-s15' : ''}`} data-testid={"cartItemPrice"}>{`\$${persistZero(price)}`}</span>
            </span>
            </>
        )}
      </span>
    </div>
  );
};

export default ItemPrice;
